import { Card } from 'antd'
import styled from 'styled-components'
import { padding } from 'theme/mixins'

const InviteCard = styled(Card)`
	.ant-card-body {
		padding-top: ${padding('xs')};
		padding-bottom: ${padding('xs')};
		display: flex;
		align-items: center;
	}
`

export default { InviteCard }
